import { z } from 'zod';
/**
 * OS access-token contract (docs/SSO.md). Frozen: breaking changes require a major version
 * of @os/app-sdk and an entry in docs/CHANGELOG.md.
 */
export const AppRolesClaimSchema = z.object({ id: z.string(), roles: z.array(z.string()) });
export const OsClaimsSchema = z.object({
    iss: z.string(),
    aud: z.union([z.string(), z.array(z.string())]),
    /** OS user id (uuid). Apps store it as `platform_user_id`. */
    sub: z.string(),
    email: z.string().email().optional(),
    name: z.string().optional(),
    /** Organisation id — every app table carries it as `tenant_id`. */
    tenant_id: z.string().optional(),
    apps: z.array(AppRolesClaimSchema).default([]),
    iat: z.number().optional(),
    exp: z.number().optional(),
    nonce: z.string().optional(),
    /** Present on client_credentials tokens. */
    client_id: z.string().optional(),
});
/** Roles granted to the token holder for `appId` (empty when none). */
export function rolesForApp(claims, appId) {
    return claims.apps?.find((a) => a.id === appId)?.roles ?? [];
}
export function principalFromClaims(claims, appId) {
    return {
        platformUserId: claims.sub,
        tenantId: claims.tenant_id ?? null,
        email: claims.email ?? null,
        displayName: claims.name ?? null,
        roles: rolesForApp(claims, appId),
        apps: claims.apps ?? [],
        isService: !!claims.client_id,
    };
}
/** The OS itself is an app: its admin role. */
export const OS_APP_ID = 'os';
export const OS_ADMIN_ROLE = 'admin';
//# sourceMappingURL=claims.js.map